export enum UnitType {
  FREQUENCY = 'FREQUENCY',
  BYTES = 'BYTES',
  RATE = 'RATE',
  COUNT = 'COUNT',
  PERCENTAGE = 'PERCENTAGE',
  VCPUS = 'VCPUS',
}

export interface ScalingThreshold {
  min: number
  max: number
  unit: string
  divisor: number
}

export interface ScalingRule {
  thresholds: ScalingThreshold[]
  precision: number
}

export const UNIT_TYPE_MAP: Record<string, UnitType> = {
  GHz: UnitType.FREQUENCY,
  GiB: UnitType.BYTES,
  GB: UnitType.BYTES,
  Kbps: UnitType.RATE,
  Mbps: UnitType.RATE,
  Gbps: UnitType.RATE,
  IOPS: UnitType.COUNT,
  '%': UnitType.PERCENTAGE,
  vCPUs: UnitType.VCPUS,
}

export const SCALING_RULES: Record<UnitType, ScalingRule> = {
  [UnitType.RATE]: {
    thresholds: [
      { min: 0, max: 1000, unit: 'Kbps', divisor: 1 },
      { min: 1000, max: 1000000, unit: 'Mbps', divisor: 1000 },
      { min: 1000000, max: Infinity, unit: 'Gbps', divisor: 1000000 },
    ],
    precision: 2,
  },
  [UnitType.COUNT]: {
    thresholds: [
      { min: 0, max: 1000, unit: 'IOPS', divisor: 1 },
      { min: 1000, max: 1000000, unit: 'K IOPS', divisor: 1000 },
      { min: 1000000, max: Infinity, unit: 'M IOPS', divisor: 1000000 },
    ],
    precision: 2,
  },
  [UnitType.BYTES]: {
    thresholds: [
      { min: 0, max: 1024, unit: 'GB', divisor: 1 },
      { min: 1024, max: Infinity, unit: 'TB', divisor: 1024 },
    ],
    precision: 2,
  },
  [UnitType.VCPUS]: {
    thresholds: [{ min: 0, max: Infinity, unit: 'vCPUs', divisor: 1 }],
    precision: 2,
  },
  [UnitType.FREQUENCY]: {
    thresholds: [{ min: 0, max: Infinity, unit: 'GHz', divisor: 1 }],
    precision: 2,
  },
  [UnitType.PERCENTAGE]: {
    thresholds: [{ min: 0, max: Infinity, unit: '%', divisor: 1 }],
    precision: 2,
  },
}
